import { useState } from 'react';
import { sendPasswordRecovery } from '../lib/passwordRecovery';

interface ForgotPasswordProps {
  onBack: () => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await sendPasswordRecovery(email);
      setSubmitted(true);
    } catch (requestError) {
      setError(requestError instanceof Error ? requestError.message : 'Unable to send password reset instructions right now. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-md">
        <h2 className="mb-2 text-2xl font-semibold">Forgot Password</h2>
        <p className="mb-6 text-sm text-gray-600">Enter the email address associated with your ETA account.</p>
        {submitted ? (
          <p role="status" className="mb-6 text-sm leading-relaxed text-green-800">
            If an account exists for this email, you'll receive a password reset link.
          </p>
        ) : (
          <form onSubmit={(event) => void submit(event)} className="space-y-4">
            <div>
              <label htmlFor="recovery-email" className="block text-sm font-medium text-gray-700">Email</label>
              <input
                id="recovery-email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                className="mt-1 block min-h-[44px] w-full rounded border border-gray-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-mainBlue"
                placeholder="you@example.com"
              />
            </div>
            {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
            <button
              type="submit"
              disabled={submitting}
              className="min-h-[48px] w-full rounded-md bg-mainPink py-3.5 font-medium text-white transition-colors hover:bg-mainBlue disabled:opacity-50"
            >
              {submitting ? 'Sending…' : 'Send Reset Link'}
            </button>
          </form>
        )}
        <button type="button" onClick={onBack} className="mt-4 min-h-[44px] text-sm font-medium text-mainBlue hover:underline">
          Back to login
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;